import { useIO, useModel } from "@type-r/react"
import React from "react"
import { ImportTemplateDetailsDto } from "../../api/importTemplateDetails"
import { IngestionJob } from "../../api/ingestionJob"
import { AddMultiAssetsStep } from "./add-multiassets-step"
import { ConfirmMultiAssetsDataStep } from "./confirm-multiassets-data-step"
import { InblockedMultiAssetsDataStep } from "./inblocked-multiassets-data-step"

export const MultiAssetWorkflow = ({ isEdit, workflowStep, job, next, back, cancel, startOver, importTemplateId, $refreshEvents }:
    { isEdit: boolean, workflowStep: number, job: IngestionJob, next, back, cancel, startOver, importTemplateId, $refreshEvents }) => {

    const importTemplate = useModel(ImportTemplateDetailsDto);

    const isReady = useIO(
        async () => {
            if (importTemplateId) {
                await importTemplate.get(importTemplateId).catch(e => console.error(e));
            }
        }, [importTemplateId]
    );

    const isAddStepEnabled = () => {
        if (isEdit) return false;
        return workflowStep === 1;
    }

    const isConfirmDataStepEnabled = () => {
        if (isEdit && workflowStep == 0) return true;
        return workflowStep === 2;
    }

    const isInblockedDataStepEnabled = () => {
        if (isEdit && workflowStep == 1) return true;
        return workflowStep === 3;
    }

    return isReady && <>
        {isAddStepEnabled() && <AddMultiAssetsStep job={job} next={next} back={back} cancel={cancel} />}
        {isConfirmDataStepEnabled() && <ConfirmMultiAssetsDataStep isEdit={isEdit} job={job} next={next} cancel={cancel} startOver={startOver} assetTypeMultiOptions={importTemplate.assetTypes} $refreshEvents={$refreshEvents}/>}
        {isInblockedDataStepEnabled() && <InblockedMultiAssetsDataStep job={job} back={back} assetTypeMultiOptions={importTemplate.assetTypes} $refreshEvents={$refreshEvents}/>}
    </>
}
